export default __webpack_public_path__ + "static/media/oldmale.596eadac.svg";